import { useQuery } from '@tanstack/react-query';

import { fetchLatestLinkedInConfigurationHistory } from '../api/configuration';
import { fetchLinkedInTeam } from '../api/team';
import type { LinkedInConfigurationHistoryEntry, LinkedInTeamResult } from '../types';
import { configurationKeys, teamKeys } from './queryKeys';

/**
 * The company's AI team, or **null** when it has not built one (LA-107).
 *
 * <p>Not having a team is an answer and not a failure, so the Launch screen builds one and a screen that
 * needs the team's readiness reads null as "not built". Not retried: a 404 is settled, and a failure is
 * shown rather than hidden behind a spinner.
 */
export function useLinkedInTeam() {
  return useQuery<LinkedInTeamResult | null>({
    queryKey: teamKeys.detail(),
    queryFn: fetchLinkedInTeam,
    retry: false,
  });
}

/** The configuration's version before its last change: what the review of changes compares with (LA-86). */
export function useLatestConfigurationHistory(enabled: boolean) {
  return useQuery<LinkedInConfigurationHistoryEntry | null>({
    queryKey: configurationKeys.latestHistory(),
    queryFn: fetchLatestLinkedInConfigurationHistory,
    enabled,
    retry: false,
  });
}
